import { useRef, useEffect } from 'react'
import { DoubleSide } from 'three'

export default function Room({ ...props }) {
  const test = useRef()

  useEffect(() => {
    test.current.material.side = DoubleSide
  }, [])

  return (
    <>
      <mesh
        name="Room"
        ref={test}
        geometry={props.nodes.Room.geometry}
        material={props.material}
        position={[-4.901, 2.673, 6.203]}
        rotation={[0, Math.PI / 2, 0]}
        scale={1.433}
      />
    </>
  )
}
